import { render, staticRenderFns } from "./Stock-Details.vue?vue&type=template&id=7347a6c2&scoped=true&"
import script from "./Stock-Details.vue?vue&type=script&lang=js&"
export * from "./Stock-Details.vue?vue&type=script&lang=js&"
import style0 from "./Stock-Details.vue?vue&type=style&index=0&id=7347a6c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7347a6c2",
  null
  
)

export default component.exports